import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Do I have to clean the totes?',
      answer: 'No. We sanitize all totes between rentals.'
    },
    {
      question: 'How far in advance should I reserve?',
      answer: 'We recommend reserving at least one week before your move.'
    },
    {
      question: 'What if I need more totes?',
      answer: 'You can add extra totes to your order anytime.'
    },
    {
      question: 'What if I need them longer?',
      answer: 'Additional days are available for a small fee.'
    },
    {
      question: 'What if I break or lose a tote?',
      answer: 'Stuff happens. If you damage or lose a tote or two, we\'ll get it figured out. If it\'s 3 or more you would incur a replacement charge.'
    },
    {
      question: 'How many totes will I need?',
      answer: 'Most customers choose one of our standard packages based on home size. Apartment / small move: about 12–15 totes. 2–3 bedroom home: about 20–30 totes. Larger homes: 50+ totes. If you\'re unsure, contact us and we can help estimate the right amount for your move.'
    },
    {
      question: 'Do the lids lock or snap shut?',
      answer: 'Yes. Each tote has a secure lid that snaps closed to help keep your belongings protected during your move.'
    },
    {
      question: 'Do I need tape with these totes?',
      answer: 'No. One of the biggest benefits of moving totes is that no packing tape is required. Simply place the lid on the tote and it\'s ready to stack.'
    },
    {
      question: 'Where do you deliver the totes?',
      answer: 'We deliver the totes directly to your home, apartment, or office. They can typically be placed in your garage, driveway, porch, or another convenient location.'
    },
    {
      question: 'Do I need to be home for delivery or pickup?',
      answer: 'No. As long as we have a safe drop-off and pickup location, you do not need to be home.'
    },
    {
      question: 'Why use totes instead of cardboard boxes?',
      answer: 'Plastic moving totes are stronger and stack more securely than cardboard boxes. They also eliminate the hassle of buying boxes, buying tape, assembling boxes, and throwing them away after your move.'
    },
    {
      question: 'What happens if it rains on moving day?',
      answer: 'Unlike cardboard boxes, plastic totes do not get soggy or collapse in rain or snow. Your belongings stay protected even if you are moving in bad weather.'
    },
    {
      question: 'How much weight can a tote hold?',
      answer: 'Each tote is designed to hold typical household items and stack securely during transport.'
    },
    {
      question: 'What areas do you serve?',
      answer: 'BoxFreeMove provides moving tote delivery throughout Grand Rapids and surrounding communities.'
    },
    {
      question: 'What are reusable moving boxes?',
      answer: 'Reusable moving boxes are durable plastic totes that are used instead of cardboard boxes when moving. They are stronger, stack better, and eliminate the need for packing tape.'
    },
    {
      question: 'Are plastic moving boxes better than cardboard boxes?',
      answer: 'Plastic moving totes are stronger, stack better, and are not damaged by rain or moisture like cardboard boxes.'
    },
    {
      question: 'How many moving boxes do I need for my move?',
      answer: 'The number of boxes depends on the size of your home and how many belongings you have. Smaller apartments may require around 12-15 boxes, while larger homes may require 50 or more.'
    },
    {
      question: 'Can moving boxes get wet in the rain?',
      answer: 'Cardboard boxes can weaken and collapse when they get wet. Plastic moving totes stay strong and protect your belongings even if it rains during your move.'
    },
    {
      question: 'Is renting moving boxes cheaper than buying them?',
      answer: 'In many cases renting moving totes costs about the same as buying cardboard boxes and packing tape, while eliminating the hassle of assembling boxes and throwing them away afterward.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-gray-600">
            Everything you need to know about BoxFreeMove
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-600 transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}